import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { RentalPropertyOwner } from '../../../domain/model/properties/rentalPropertyOwners';
import { CommonServices } from '../../../domain/service/commonService';
import { GooglePlacesService } from '../../../domain/service/GooglePlaceService';
import { PropertyService } from '../../../domain/service/propertyService';

@Component({
  selector: 'app-properties-single-owner',
  templateUrl: './properties-single-owner.component.html',
  styleUrl: './properties-single-owner.component.css'
})
export class PropertiesSingleOwnerComponent implements OnInit , OnChanges{
  @Input() dataOwners!: RentalPropertyOwner[];
  @Output() formChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  owner!:RentalPropertyOwner;
  addressType:string = '1';
  states: DropDownModel[] = [];
  suggestions: any[] = [];
  countries: DropDownModel[] = [];
  ownerForm !: FormGroup;
  public hasChange: boolean = false;
  constructor(private readonly propertyService: PropertyService,
               private googlePlacesService: GooglePlacesService, 
               private commonServices: CommonServices,
                  private fb: FormBuilder){
  
 
  }
  ngOnChanges(changes: SimpleChanges): void { 
     
    this.owner = this.dataOwners[0];
    this.buildForm(this.owner)
  }
    private buildForm(info: RentalPropertyOwner | undefined): void {
      console.log(info)
      this.ownerForm =  this.fb.group({
        firstName: new FormControl(info?.firstName, [
          Validators.required,
          Validators.maxLength(200),
        ]),
        lastName: new FormControl(info?.lastName, [
          Validators.required,
          Validators.maxLength(200),
        ]),
        email: new FormControl(info?.email, [
          Validators.required,
          Validators.maxLength(320),
          Validators.email
        ]),
        phoneNumber: new FormControl(info?.phoneNumber, [
          Validators.required,
          Validators.maxLength(100),
          Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
        ]),
        ownerStreetAddress: new FormControl(info?.streetAddress),
        aptUnitSuite: new FormControl(info?.aptUnitSuite),
        city: new FormControl(info?.city),
        state: new FormControl(info?.stateId),
        zipCode:new FormControl(info?.zipCode),
        addressName: new FormControl(info?.addressName),
        addressOrPoBox: new FormControl(info?.streetAddressOrPoBox),
        cityStateProvince: new FormControl(info?.cityStateProvince),
        country: new FormControl(info?.countryId),
        addressType: new FormControl(info?.addressType),
      });
      this.ownerForm.get('ownerStreetAddress')?.valueChanges.subscribe((value) => {
        if (value) {
          this.googlePlacesService.getPlaces(value).then((predictions: any) => {
            this.suggestions = predictions;
            console.log(this.suggestions)
          });
        } else {
          this.suggestions = [];
        }
      });
     this.addressType = info?.addressType.toString()??'1';
     this.setRequireValuesToAddress(this.addressType)
      this.ownerForm.valueChanges.subscribe((newValues) => {
        console.log(newValues)
        this.hasChange = this.ownerForm.valid;
        this.formChanged.emit(this.ownerForm.valid);
      });
    }
  ngOnInit(): void {
    this.commonServices.getAllCountry()
    .subscribe(data => {
      this.countries = data.sort((a,b) => a.name.localeCompare(b.name));;
    });
    this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data.sort((a,b) => a.name.localeCompare(b.name));
    });
      if (this.dataOwners && this.dataOwners.length > 0)
      {
        this.owner = this.dataOwners[0];
      
      }

  }

  radioChangeAddress(event: any) {
    this.addressType = event.value;
    this.setRequireValuesToAddress(event.value)
    
  }     

  setRequireValuesToAddress(addressType: string){
    if(addressType == "1"){
      this.ownerForm.get('addressName')?.clearValidators();
      this.ownerForm.get('addressName')?.updateValueAndValidity();
  
      this.ownerForm.get('addressOrPoBox')?.clearValidators();
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();
  
      this.ownerForm.get('cityStateProvince')?.clearValidators();
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();
  
      this.ownerForm.get('country')?.clearValidators();
      this.ownerForm.get('country')?.updateValueAndValidity();
  
      this.ownerForm.get('ownerStreetAddress')?.addValidators(Validators.required);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
  
 
  
      this.ownerForm.get('city')?.addValidators(Validators.required);
      this.ownerForm.get('city')?.updateValueAndValidity();
  
      this.ownerForm.get('state')?.addValidators(Validators.required);
      this.ownerForm.get('state')?.updateValueAndValidity();
  
      this.ownerForm.get('zipCode')?.addValidators( Validators.required);
      this.ownerForm.get('zipCode')?.addValidators(Validators.maxLength(12));
      this.ownerForm.get('zipCode')?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.ownerForm.get('zipCode')?.updateValueAndValidity();
  
    }
    if(addressType == "2"){
  
      this.ownerForm.get('addressName')?.addValidators(Validators.required);
      this.ownerForm.get('addressName')?.updateValueAndValidity();
  
      this.ownerForm.get('addressOrPoBox')?.addValidators(Validators.required);
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();
  
      this.ownerForm.get('cityStateProvince')?.addValidators(Validators.required);
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();
  
      this.ownerForm.get('country')?.addValidators(Validators.required);
      this.ownerForm.get('country')?.updateValueAndValidity();
  
   
      this.ownerForm.get('ownerStreetAddress')?.clearValidators();
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
  
      this.ownerForm.get('aptUnitSuite')?.clearValidators();
      this.ownerForm.get('aptUnitSuite')?.updateValueAndValidity();
  
      this.ownerForm.get('city')?.clearValidators();
      this.ownerForm.get('city')?.updateValueAndValidity();
  
      this.ownerForm.get('state')?.clearValidators();
      this.ownerForm.get('state')?.updateValueAndValidity();
  
      this.ownerForm.get('zipCode')?.clearValidators();
      this.ownerForm.get('zipCode')?.updateValueAndValidity();
    }

  }
   async selectPlaceOwner(place: any) {
      console.log(place);
     
      this.suggestions = [];
      const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
      let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);
    
      if (selectedZipCode.zip){
        this.ownerForm.get('zipCode')?.setValue(selectedZipCode.zip);
      }
    
      if (selectedZipCode.city){
        this.ownerForm.get('city')?.setValue(selectedZipCode.city);
      }
    
      if (selectedZipCode.stateCode){
        let stateId = this.states.find(e => e.iso2 ==selectedZipCode.stateCode )?.id ?? 0;
        console.log(stateId.toString());
        this.ownerForm.get('state')?.setValue(stateId);
      }
      if (selectedZipCode.address){
        this.ownerForm.get('ownerStreetAddress')?.setValue(selectedZipCode.address);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
      this.ownerForm.get('ownerStreetAddress')?.markAsUntouched();
      }
    }

    save() : void {
      

       let model : RentalPropertyOwner = {
         accountPropertyId: this.owner.accountPropertyId,
         id: this.owner.id,
         firstName: this.ownerForm.get('firstName')?.value ?? '',
         lastName: this.ownerForm.get('lastName')?.value ?? '',
         email: this.ownerForm.get('email')?.value ?? '',
         phoneNumber: this.ownerForm.get('phoneNumber')?.value ?? '',
         internalId: '1',
         streetAddress: this.ownerForm.get('ownerStreetAddress')?.value ?? '',
         aptUnitSuite: this.ownerForm.get('aptUnitSuite')?.value ?? '',
         city: this.ownerForm.get('city')?.value ?? '',
         zipCode: this.ownerForm.get('zipCode')?.value ?? '',
         internationalAddressName: this.ownerForm.get('addressName')?.value ?? '',
         addressName: this.ownerForm.get('addressName')?.value ?? '',
         internationalPoboxNumber: this.ownerForm.get('addressOrPoBox')?.value ?? '',
         internationalCityStateProvince: this.ownerForm.get('cityStateProvince')?.value ?? '',
         stateId: this.ownerForm.get('state')?.value ?? 0,
         countryId: this.ownerForm.get('country')?.value ?? 0,
         addressType: Number.parseInt(this.addressType) ?? 0,
         accountId: this.owner.accountId,
         streetAddressOrPoBox:  this.ownerForm.get('addressOrPoBox')?.value ?? '',
         cityStateProvince: this.ownerForm.get('cityStateProvince')?.value ?? ''
       };

       let data : RentalPropertyOwner[] = [];
       data.push(model);
       this.propertyService.updateOwners(data).subscribe({
        next: (response) => {
      
        },
        error: (error) => {
        
        },
        complete: () => { 
          this.formChanged.emit(true);
        }
      });
    }
}
